export default {"src":"/_next/static/media/CertificateAndDocuments.4de9af92.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};